/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type InjuryTypeDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: InjuryTypeDefinitionDto.source;
    label?: string;
}

export namespace InjuryTypeDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
